export enum SearchActions {
  LoadSearch = 'Load all dependencies for search',
  SearchIsReady = 'Add dependencies for search are ready',
  SearchLoadingFailed = 'Some dependencies have failed to load',
}
